/*
 * Author: zoesvision.com
 * Purpose: Manage isolated countdown Theme Block states before, during, and after an event.
 */

class ZCountdown extends HTMLElement {
  connectedCallback() {
    if (this.isConnectedToTimer) return;

    this.isConnectedToTimer = true;
    this.values = {
      days: this.querySelector('[data-z-countdown-days]'),
      hours: this.querySelector('[data-z-countdown-hours]'),
      minutes: this.querySelector('[data-z-countdown-minutes]'),
      seconds: this.querySelector('[data-z-countdown-seconds]'),
    };
    this.message = this.querySelector('[data-z-countdown-message]');
    this.time = this.querySelector('[data-z-countdown-time]');
    this.startTime = this.parseTime(this.dataset.zCountdownStart || '');
    this.endTime = this.parseTime(this.dataset.zCountdownEnd || '');
    this.update();

    if (this.state !== 'ended') {
      this.timer = setInterval(() => this.update(), 1000);
    }
  }

  disconnectedCallback() {
    this.stop();
    this.isConnectedToTimer = false;
  }

  update() {
    const resolved = ZCountdown.resolveState(this.startTime, this.endTime, Date.now());
    this.state = resolved.state;

    if (this.message) this.message.textContent = this.dataset[`zCountdown${resolved.message}Text`] || '';
    if (this.time) {
      this.time.hidden = resolved.target === null;
      this.time.dateTime = resolved.target === this.startTime
        ? this.dataset.zCountdownStart || ''
        : this.dataset.zCountdownEnd || '';
    }

    if (resolved.target === null) {
      this.stop();
      return;
    }

    const totalSeconds = Math.max(0, Math.ceil((resolved.target - Date.now()) / 1000));

    this.render({
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    });
  }

  parseTime(value) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2}$/.test(value)
      ? Date.parse(value)
      : Number.NaN;
  }

  static resolveState(startTime, endTime, now) {
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || endTime <= startTime) {
      return { state: 'ended', message: 'Ended', target: null };
    }
    if (now < startTime) return { state: 'upcoming', message: 'Before', target: startTime };
    if (now < endTime) return { state: 'active', message: 'Active', target: endTime };
    return { state: 'ended', message: 'Ended', target: null };
  }

  render(parts) {
    Object.entries(parts).forEach(([name, value]) => {
      if (this.values[name]) this.values[name].textContent = String(value).padStart(2, '0');
    });
  }

  stop() {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = undefined;
  }
}

if (!customElements.get('z-countdown')) {
  customElements.define('z-countdown', ZCountdown);
}
